import { makeStyles } from "@material-ui/core/styles";
import { deepOrange } from '@material-ui/core/colors';

const drawerWidth = 240;

export default makeStyles((theme) => ({
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerHeaderProfile: {
    display: "flex",
    alignItems: "center",
    flexFlow: "column",
    padding: theme.spacing(1, 2),
    ...theme.mixins.toolbar,
    justifyContent: "center",
    gap: "2px"
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: "flex-end",
  },
  links: {
    color: "#757575",
    textDecoration: "none",
  },
  orange: {
    color: theme.palette.getContrastText(deepOrange[500]),
    backgroundColor: deepOrange[500],
  },
}));
